export const HugType = {
    HEART: "HugType.HEART",
    PRAY: "HugType.PRAY",
    IDEA: "HugType.IDEA",
    FUNNY: "HugType.FUNNY",
    CLAP: "HugType.CLAP",
    BEE: "HugType.BEE"
};